var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"location-auto-detect"},[_c('div',{staticClass:"map-container",attrs:{"id":"location-auto-detect-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }